import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPartnerWebhookEventTypeDescription.ts
var t = () => e("partnerWebhookEventTypeDescription");
//#endregion
export { t as useTrPartnerWebhookEventTypeDescription };
